export const UPLOAD_IMAGE_BEGIN = "upload_image_begin"
export const UPLOAD_IMAGE_SUCCESS = "upload_image_success"
export const UPLOAD_IMAGE_FAILURE = "upload_image_failure"